var _defs, _path, _g, _g2, _g3, _g4, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a6bc161a35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.105469 25.3125 L 107.992188 25.3125 L 107.992188 129.199219 L 4.105469 129.199219 Z M 4.105469 25.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a6a0663031"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.050781 25.3125 C 27.363281 25.3125 4.105469 48.570312 4.105469 77.257812 C 4.105469 105.945312 27.363281 129.199219 56.050781 129.199219 C 84.738281 129.199219 107.992188 105.945312 107.992188 77.257812 C 107.992188 48.570312 84.738281 25.3125 56.050781 25.3125 Z M 56.050781 25.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8e73fdb4e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.105469 246.269531 L 107.992188 246.269531 L 107.992188 350.15625 L 4.105469 350.15625 Z M 4.105469 246.269531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c1e50deaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.050781 246.269531 C 27.363281 246.269531 4.105469 269.523438 4.105469 298.210938 C 4.105469 326.898438 27.363281 350.15625 56.050781 350.15625 C 84.738281 350.15625 107.992188 326.898438 107.992188 298.210938 C 107.992188 269.523438 84.738281 246.269531 56.050781 246.269531 Z M 56.050781 246.269531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c515e8ffc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 266.996094 24.835938 L 370.882812 24.835938 L 370.882812 128.722656 L 266.996094 128.722656 Z M 266.996094 24.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f7481f0f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 318.9375 24.835938 C 290.25 24.835938 266.996094 48.089844 266.996094 76.777344 C 266.996094 105.464844 290.25 128.722656 318.9375 128.722656 C 347.625 128.722656 370.882812 105.464844 370.882812 76.777344 C 370.882812 48.089844 347.625 24.835938 318.9375 24.835938 Z M 318.9375 24.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "953ad199dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117.308594 245.789062 L 221.195312 245.789062 L 221.195312 349.675781 L 117.308594 349.675781 Z M 117.308594 245.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0fff0b7390"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.253906 245.789062 C 140.566406 245.789062 117.308594 269.042969 117.308594 297.730469 C 117.308594 326.421875 140.566406 349.675781 169.253906 349.675781 C 197.941406 349.675781 221.195312 326.421875 221.195312 297.730469 C 221.195312 269.042969 197.941406 245.789062 169.253906 245.789062 Z M 169.253906 245.789062 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, -0.75, 0.75, 0, 35.78935, 269.544357)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.0018506 27.999618 L 220.715407 27.999618 ",
    stroke: "#5c9ce6",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a6bc161a35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a6a0663031)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 4.106845, 25.313553)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 69.258587 -0.00140418 C 31.008584 -0.00140418 -0.00183451 31.009015 -0.00183451 69.259017 C -0.00183451 107.50902 31.008584 138.51423 69.258587 138.51423 C 107.508589 138.51423 138.5138 107.50902 138.5138 69.259017 C 138.5138 31.009015 107.508589 -0.00140418 69.258587 -0.00140418 Z M 69.258587 -0.00140418 ",
    stroke: "#5c9ce6",
    strokeWidth: 80,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8e73fdb4e3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c1e50deaf)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 4.106845, 246.26846)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 69.258587 0.00142856 C 31.008584 0.00142856 -0.00183451 31.006639 -0.00183451 69.256641 C -0.00183451 107.506644 31.008584 138.517063 69.258587 138.517063 C 107.508589 138.517063 138.5138 107.506644 138.5138 69.256641 C 138.5138 31.006639 107.508589 0.00142856 69.258587 0.00142856 Z M 69.258587 0.00142856 ",
    stroke: "#5c9ce6",
    strokeWidth: 80,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c515e8ffc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f7481f0f4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 266.99571, 24.834022)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 69.255724 0.00255415 C 31.005722 0.00255415 0.000511444 31.007765 0.000511444 69.257767 C 0.000511444 107.50777 31.005722 138.518188 69.255724 138.518188 C 107.505727 138.518188 138.516146 107.50777 138.516146 69.257767 C 138.516146 31.007765 107.505727 0.00255415 69.255724 0.00255415 Z M 69.255724 0.00255415 ",
    stroke: "#5c9ce6",
    strokeWidth: 80,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#953ad199dd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0fff0b7390)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 117.310221, 245.789045)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 69.258252 0.0000227202 C 31.008249 0.0000227202 -0.0021694 31.005233 -0.0021694 69.255236 C -0.0021694 107.510446 31.008249 138.515657 69.258252 138.515657 C 107.508254 138.515657 138.513465 107.510446 138.513465 69.255236 C 138.513465 31.005233 107.508254 0.0000227202 69.258252 0.0000227202 Z M 69.258252 0.0000227202 ",
    stroke: "#5c9ce6",
    strokeWidth: 80,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 153.448238, 55.782652)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 60.88152 322.607527 L 144.897151 322.607527 C 185.59507 322.607527 218.589864 289.612734 218.589864 248.914814 C 218.589864 208.211687 185.59507 175.222101 144.897151 175.222101 L 101.61069 175.222101 C 82.089855 175.222101 63.365896 167.466892 49.558603 153.6596 C 35.756519 139.857515 28.00131 121.133556 28.00131 101.607513 C 28.00131 82.086678 35.756519 63.362719 49.558603 49.560635 C 63.365896 35.753342 82.089855 27.998133 101.61069 27.998133 L 185.709654 27.998133 ",
    stroke: "#5c9ce6",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.f7b3d22e55627ae3bf6145b13e153636.svg";
export { ForwardRef as ReactComponent };